export const sendWhatsappMessage = (text: string, numberphone: string) => {
  const isWindows = navigator.userAgent.indexOf('Windows') !== -1;

  let url = '';

  if (isWindows) {
    url = `https://wa.me/${numberphone}?text=${text}`;
  } else {
    url = `whatsapp://send?text=${text}&phone=${numberphone}`;
  }

  // Não usar setTimeout pois gera comportamento irregular no iOS
  // setTimeout(() => {
  window.open(url, '_blank');
  // }, 1000);
};
